import React from 'react'
import RaisedButton from 'material-ui/RaisedButton';
import TextField from '@material-ui/core/TextField'
import FormControl from '@material-ui/core/FormControl'
import EmailValidator from 'email-validator';
import InputLabel from '@material-ui/core/InputLabel'
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Popover from '@material-ui/core/Popover';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Info from '@material-ui/icons/Info'
import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import FormHelperText from '@material-ui/core/FormHelperText'
import Snackbar from '@material-ui/core/Snackbar';
import { checkVendorActivePayments, getStatesAndCities } from '../utils/VendorApiUtils'
import userdata from '../config/jwt_token'
import { browserHistory } from 'react-router'
const errorText = 'This field is required'
class VendorBasicDetails extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      data: {
        name: '',
        contact_person_name: '',
        address: '',
        city_name: '',
        city_id: '',
        state_name: '',
        contact_number: '',
        alternate_contact_number: '',
        email_id: '',
        national: 0,
      },
      cities: [],
      nameErrText: '',
      contact_person_nameErrText: '',
      addressErrText: '',
      city_nameErrText: '',
      state_nameErrText: '',
      contact_numberErrText: '',
      alternate_contact_numberErrText: '',
      nameErr: false,
      contact_person_nameErr: false,
      addressErr: false,
      city_nameErr: false,
      state_nameErr: false,
      contact_numberErr: false,
      alternate_contact_numberErr: false,
      snackText: '',
      snackOpen: false,
      popOverConfig: {
        open: false,
        anchorEl: null,
        content: '',
        auxContent: '',
      },
      nationalVendorDialogBox: false,
      nationalVendorDialogBoxText: '',
      NationalVendortooltipText: '* National vendors can be used to raise payment requests across mulitple cities.',
      NationalVendortooltipActionText:'* Please tick if you want this vendor to be used by other city finance teams as well.',
      vendorActivePaymentsDialogBox: {
        open: false,
        message: 'This vendor has active payments, please deactivate payments first before editing',
      },
      vendorActivePayments: []
    }
  }
  componentDidMount(props) {
    if (this.props.data) {
      this.setState({ data: this.props.data })
    }
    const selectedCity = localStorage.getItem('selected_city')
    getStatesAndCities().then((response) => {
      if (response && response.status === 'success') {
        let userCity = response.data.find((e)=>e.city_name === selectedCity)
        if(userCity) {
          this.setState({ 
            data:{ ...this.state.data, city_name: userCity.city_name, city_id: userCity.city_id, state_name: userCity.state_name}
          })
        }
      }
    })
  }
  async componentWillReceiveProps(nextProps) {
    if (nextProps.data) {
    if(nextProps.data.vendor_buffer_id) {
      const isActivePayments = await this.fetchVendorActivePayments(nextProps.data.vendor_buffer_id);
      if (isActivePayments && isActivePayments.flag && isActivePayments.data.length > 0) {
        this.setState({
          vendorActivePaymentsDialogBox: {
            ...this.state.vendorActivePaymentsDialogBox,
            open: true,
          },
          vendorActivePayments: isActivePayments.data
        })
      }
    }
      const selectedCity = localStorage.getItem('selected_city')
      if(['City Finance','City Head'].indexOf(userdata.role) !== -1 && nextProps.data.city_name !== selectedCity)
        this.setState({nationalVendorDialogBox: true, nationalVendorDialogBoxText: `This vendor can only be edited/deleted by the city-finance team of ${nextProps.data.city_name}. Please contact them.`  })
      else 
        this.setState({data: nextProps.data})
    }
  }

  async fetchVendorActivePayments (vendor_buffer_id) {
    const response = await checkVendorActivePayments(vendor_buffer_id);
    return response;
  }

  handleChange = (props) => (event, index, value) => {
    if (props === 'city_name') {
      this.setState({
        data: {
          ...this.state.data, city_name: event.target.value.split(',')[0], state_name: event.target.value.split(',')[1],
          city_id: event.target.value.split(',')[2]
        }, [props + 'ErrText']: '', [props + 'Err']: false
      })
    }
    else if (props === 'national'){
      this.setState({data: {...this.state.data, [props]: event.target.checked?1:0}})
    }
    else if (props === 'contact_number' || props === 'alternate_contact_number') {
      let myregex = /^\d{0,10}$/
      if (!myregex.test(event.target.value)) {
        this.setState({ snackText: 'Invalid phone number', snackOpen: true })
        return
      }
      else
        this.setState({ data: { ...this.state.data, [props]: event.target.value }, [props + 'ErrText']: '', [props + 'Err']: false })
    }
    else {
      this.setState({ data: { ...this.state.data, [props]: event.target.value }, [props + 'ErrText']: '', [props + 'Err']: false })
    }
  }
  handleClick = (props) => (event, index, value) => {
    if (props !== 'contact_number' && this.state.data.contact_number !== '') {
      if (this.state.data.contact_number.length < 10) {
        this.setState({ contact_numberErrText: 'Invalid number (Max length is 10) ', contact_numberErr: true })
      }
    }
    if (props !== 'alternate_contact_number' && this.state.data.alternate_contact_number !== '' && this.state.data.alternate_contact_number) {
      if (this.state.data.alternate_contact_number.length < 10) {
        this.setState({ alternate_contact_numberErrText: 'Invalid number (Max length is 10) ', alternate_contact_numberErr: true })
      }
    }
    if (props !== 'email_id' && this.state.data.email_id !== '') {
      if (!EmailValidator.validate(this.state.data.email_id)) {
        this.setState({ email_idErrText: 'Invalid Email Id ', email_idErr: true })
      }
    }
  }
  handleNext = () => {
    if (this.state.vendorActivePayments.length > 0) {
      this.setState({
        vendorActivePaymentsDialogBox: {
          ...this.state.vendorActivePaymentsDialogBox,
          open: true,
        }
      })
      return;
    }
    if (this.state.data.name && this.state.data.name.trim() === '') {
      this.setState({ nameErrText: errorText, nameErr: true })
    }
    if (this.state.data.contact_person_name === '') {
      this.setState({ contact_person_nameErrText: errorText, contact_person_nameErr: true })
    }
    if (this.state.data.address === '') {
      this.setState({ addressErrText: errorText, addressErr: true })
    }
    if (this.state.data.city_name === '') {
      this.setState({ city_nameErrText: errorText, city_nameErr: true })
    }
    if (this.state.data.contact_number === '') {
      this.setState({ contact_numberErrText: errorText, contact_numberErr: true })
    }
    if (this.state.data.contact_number !== '') {
      let myregex = /^\d{10,11}$/
      if (!myregex.test(this.state.data.contact_number)) {
        this.setState({ snackText: 'Invalid Contact Number', snackOpen: true })
        return
      }
    }
    if (this.state.data.alternate_contact_number !== '') {
      let myregex = /^\d{10,11}$/
      if (!myregex.test(this.state.data.alternate_contact_number)) {
        this.setState({ snackText: 'Invalid Alternate Contact Number', snackOpen: true })
        return
      }
    }
    if (this.state.data.email_id !== '') {
      if (!EmailValidator.validate(this.state.data.email_id)) {
        this.setState({ snackText: 'Invalid Email', snackOpen: true })
        return
      }
    }
    if (this.state.data.name !== '' && this.state.data.contact_person_name !== '' && this.state.data.address !== '' && this.state.data.city_name !== ''
      && this.state.data.state_name !== '' && this.state.data.contact_number !== '') {
      this.setState({
        data: {
          ...this.state.data,
          name: this.state.data.name.trim(),
        }
      }, () => this.props.handleNext(this.state.data))  
    }
  }
  handleCloseSnack() {
    this.setState({ snackOpen: false })
  }
  handleCloseNationalVendorDialogBox() {
    // As of now this case is only possible with approved vendors.
    browserHistory.push(`/vendor/approved`);
  }
  handlePopOverClose = () => {
    this.setState({
      popOverConfig: {
        ...this.state.popOverConfig,
        open: false,
        anchorEl: null,
      }
    })
  }

  openInfoPopOver = (infoType) => (event) => {
    switch(infoType){
      case "National":
        this.setState({
          popOverConfig: {
            ...this.state.popOverConfig,
            open: Boolean(event.currentTarget),
            anchorEl: event.currentTarget,
            content: this.state.NationalVendortooltipText,
            auxContent: this.state.NationalVendortooltipActionText
          }
        })
        break;
      default: break;
    }
  }
  handlePopOverClose = () => {
    this.setState({
      popOverConfig: {
        ...this.state.popOverConfig,
        open: false,
        anchorEl: null,
      }
    })
  }
  handleClear() {
    this.setState({
      data: {
        ...this.state.data,
        national: 0,
        name: '',
        contact_person_name: '',
        address: '',
        contact_number: '',
        alternate_contact_number: '',
        email_id: ''
      }
    })
  }

  handleActivePaymentsDialogClose = () => {
    this.setState({ vendorActivePaymentsDialogBox: {
      ...this.state.vendorActivePaymentsDialogBox,
      open: false
    } })
  }

  render() {
    return (
      <div>
        <TextField
          label="*Vendor Name"
          placeholder="Enter Vendor Name"
          value={this.state.data.name}
          onChange={this.handleChange('name')}
          onClick={this.handleClick('name')}
          margin='normal'
          style={{ width: '520px' }}
          helperText={this.state.nameErrText}
          error={this.state.nameErr}
        /><br />
        <TextField
          label="*Contact Person Name"
          placeholder="Enter Name"
          value={this.state.data.contact_person_name}
          onChange={this.handleChange('contact_person_name')}
          onClick={this.handleClick('contact_person_name')}
          margin='normal'
          style={{ width: '250px', marginRight: '270px' }}
          helperText={this.state.contact_person_nameErrText}
          error={this.state.contact_person_nameErr}
        /><br />
        <TextField
          label="*Vendor address"
          placeholder="Enter Vendor address"
          value={this.state.data.address}
          onChange={this.handleChange('address')}
          onClick={this.handleClick('address')}
          margin='normal'
          multiline
          style={{ width: '520px' }}
          helperText={this.state.addressErrText}
          error={this.state.addressErr}
        /><br />
        <FormControl margin='normal'>
          <TextField
            label="City"
            placeholder="Vendor City"
            value={this.state.data.city_name}
            margin='normal'
            style={{ width: '250px', marginRight: '8px' }}
            helperText={this.state.city_nameErrText}
            error={this.state.city_nameErr}
            InputProps={{
              readOnly: true,
            }}
          />
        </FormControl>
        <FormControlLabel style={{ width: '250px', marginLeft: '20px'}}
          control={
            <Checkbox
              checked={this.state.data.national}
              onChange={this.handleChange('national')}
              value='national'
              color="primary"
              data-tooltip="hello"
            />
          }
          label={<div><span>*</span>National Vendor</div>}
          />
          <Info fontSize="small" style={{ cursor: 'pointer' }} onClick={this.openInfoPopOver('National')} />
        <TextField
          label="*Contact Number"
          placeholder="Enter Contact Number"
          value={this.state.data.contact_number}
          onChange={this.handleChange('contact_number')}
          onClick={this.handleClick('contact_number')}
          margin='normal'
          style={{ width: '250px', marginRight: '8px' }}
          helperText={this.state.contact_numberErrText}
          error={this.state.contact_numberErr}
        />
        <TextField
          label="Alternate Number"
          placeholder="Enter Alternate Number"
          value={this.state.data.alternate_contact_number}
          onClick={this.handleClick('alternate_contact_number')}
          onChange={this.handleChange('alternate_contact_number')}
          margin='normal'
          style={{ width: '250px', marginLeft: '12px' }}
          helperText={this.state.alternate_contact_numberErrText}
          error={this.state.alternate_contact_numberErr}
        />
        <TextField
          label="Email id"
          placeholder="Enter Email id"
          value={this.state.data.email_id}
          onChange={this.handleChange('email_id')}
          onClick={this.handleClick('email_id')}
          margin='normal'
          style={{ width: '520px' }}
        /><br />
        <div className="zaps-form-actions">
          <RaisedButton
            label="Clear"
            primary={true}
            onClick={this.handleClear.bind(this)}
            buttonStyle={{ backgroundColor: 'red' }}
          />
          <RaisedButton label={`Next`} primary={true} onClick={this.handleNext.bind(this)} />
        </div>
        <Dialog
          open={this.state.nationalVendorDialogBox}
          onClose={this.handleCloseNationalVendorDialogBox}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {this.state.nationalVendorDialogBoxText}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleCloseNationalVendorDialogBox} color="primary" autoFocus>
              OK
            </Button>
          </DialogActions>
        </Dialog>
        <Popover
          id="simple-popper"
          open={this.state.popOverConfig.open}
          anchorEl={this.state.popOverConfig.anchorEl}
          onClose={this.handlePopOverClose}
          anchorOrigin={{
            vertical: 'center',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
        <div  style={{ padding: '6px', border: '1px solid black', borderRadius: '4px', width:'300px'}}>
        <span style={{ margin: '5px' }}>{this.state.popOverConfig.content}</span><br/><br/>
        <span style={{ margin: '5px' }}>{this.state.popOverConfig.auxContent}</span>
        </div>
        </Popover>
        <Dialog
          open={this.state.vendorActivePaymentsDialogBox.open}
          onClose={() => this.handleActivePaymentsDialogClose()}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <div style={{ textAlign: 'center', border: '1px dashed #FF0000' }}>
              <p>{this.state.vendorActivePaymentsDialogBox.message}</p>
            </div>
          </DialogContent>
        </Dialog>
        <Snackbar
          open={this.state.snackOpen}
          autoHideDuration={1000}
          onClose={this.handleCloseSnack.bind(this)}
          message={this.state.snackText}
        />
      </div>
    )
  }

}
export default VendorBasicDetails


// WEBPACK FOOTER //
// ./src/components/VendorBasicDetails.js